import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { VisitModel } from 'src/app/models/visit.model';
import { AccommodationService } from 'src/app/services/accommodation.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-new-accommodation',
  templateUrl: './new-accommodation.component.html',
  styleUrls: ['./new-accommodation.component.scss'],
})
export class NewAccommodationComponent implements OnInit {

  newData: VisitModel = null;
  isSubmitting = false; // Add this line to track submission state

  constructor(
    private mdlctrl: ModalController,
    public dataServ: DataService,
    private authServ: AuthService,
    private accomServ: AccommodationService
  ) { }

  async ngOnInit() {
    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    this.newData = new VisitModel(this.authServ.profile);

  }

  async close() {
    await this.mdlctrl.dismiss();
  }

  async save() {
    // Prevent multiple submissions
    if (this.isSubmitting) {
      return;
    }
    
    // Set loading state
    this.isSubmitting = true;
    
    try {
      await this.accomServ.postVisit(this.newData);
      await this.mdlctrl.dismiss(true);
    } catch (error) {
      console.error('Error saving accommodation:', error);
      this.isSubmitting = false; // Reset loading state if there's an error
    }
  }
}
